export interface NotificationState {
  notifications: Notification[];
}

export type NotificationType = "success" | "warning" | "primary" | "error";
export interface Notification {
  type: NotificationType;
  title: string;
  message: string;
  timer: number;
  autoClose: boolean;
}

export function notification(
  type: NotificationType,
  title: string,
  message: string,
  timer: number,
  autoClose: boolean
) {
  return {
    type,
    title,
    message,
    timer,
    autoClose
  } as Notification;
}
